import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort, MatTableDataSource } from '@angular/material';
//import { ItemGrid } from '../../../models/item';
//import { modalComponent } from '../../../utils/modal/modal.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';

import * as jsPDF from 'jspdf';
import * as pdfMake from 'pdfmake/build/pdfmake';
import {TDocumentDefinitions} from 'pdfmake/build/pdfmake';
import { text } from '@fortawesome/fontawesome-svg-core';
// import { dataPolizaPDF } from 'src/app/models/poliza';
import { dataPolizaPDF } from '../../../models/poliza'
;
import { utils } from '../../../utils/utils';;

@Component({
    selector: 'ReporteAuxiliarCuenta-consultar',
    styleUrls: ['reporteAuxiliarCuenta-consultar.component.scss'], 
    templateUrl: 'reporteAuxiliarCuenta-consultar.component.html',
    providers: [generalService,utils]
})
export class ReporteAuxiliarCuentaConsultarComponent implements OnInit{
    myForm: FormGroup;
    dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('tableAuxCuenta') tableAuxCuenta: ElementRef;
    prevNumCuentaFormStatus: string;
    private ACCOUNT_ID = undefined;
    private DEBTOR = undefined;
    public level = 0;
    public dataReporteCuenta: any[] = []; 
    public dataReporteCuentaAux: any[] = []; 
    public nombreNumeroCuenta: any[] = [];
    public dataCuenta: any[] = [];
    public saldoInicialTotal = 0;
    public cargoTotal = 0;
    public abonoTotal = 0;
    public saldoFinalTotal = 0;
    public nombreCuneta = true;
    public ACCOUNT_SAT_ID_Flahg: boolean;
    public Anio_Flahg: boolean;
    public NUMBERCuentaExcel = '';
    public NAMECuentaExcel = '';
    public conusltaCuenta = false;
    dateRange: any = {
        startDate: moment().startOf('month'),
        //startDate: moment().subtract(7, 'days'),
        endDate: moment()
    };
    ranges: any = {
        'Hoy': [moment(), moment()],
        'Semana actual': [moment().startOf('week'), moment().endOf('week')],
        'Mes actual': [moment().startOf('month'), moment().endOf('month')]
    };
    public _utils:utils;
    displayedColumns = ['FECHA', 'POLIZA','ACCIONESPOLIZA',  'PARTIDA', 'REFERENCIA','CONCEPTOIND', 'SALDOINICIAL', 'CARGO', 'ABONO', 'SALDOFINAL'];
    constructor(private formBuilder: FormBuilder,
        private _generalService: generalService,
        private router:Router,
        private __utils: utils
    ) {
        this.myForm = new FormGroup({});
        this._utils = new utils();
    }

    ngOnInit() {
        this.consultarNivel();
        this.buildForm();
       
       // this.consultarAuxiliarCuenta();
    }
    
    buildForm(){
        this.myForm = this.formBuilder.group({
            fechasForm: ['', Validators.required],
            numCuentaForm: [''],
            nombreCuentaForm: [{ value: '', disabled: true }, Validators.required] , // Hacer nombreCuentaForm requerido
            
        }); 
        
        this.myForm.get('numCuentaForm').statusChanges.subscribe(status => {
            // Verificar si el estado anterior era inválido y el nuevo es válido
            if (this.prevNumCuentaFormStatus === 'INVALID' || status === 'VALID') {
                if(this.conusltaCuenta){ this.consultarNombreCuenta();}
               
            }
            this.prevNumCuentaFormStatus = status; // Actualizar el estado previo
        });
    
        let prevNumCuentaValue = ''; // Almacenar el valor anterior de numCuentaForm
    
        // Suscribirse al evento input en numCuentaForm para detectar cambios
        this.myForm.get('numCuentaForm').valueChanges.subscribe(value => {
            // Verificar si se ha eliminado un carácter
            if (prevNumCuentaValue.length > value.length) {
                // Resetear nombreCuentaForm
                this.myForm.get('nombreCuentaForm').reset();
            }
            prevNumCuentaValue = value; // Actualizar el valor anterior
        });

    }
    validarAnio(event: any): void {

        const start = event.startDate;
        const end = event.endDate;
    
        if (start && end) {
          const startYear = moment(start).year();
          const endYear = moment(end).year();
    
          if (startYear !== endYear) {
            this._generalService.toastCall('¡Ambas fechas del rango deben ser del mismo año!');
            this.Anio_Flahg = true;
          } else {
            this.Anio_Flahg = false;
          }
        }
    }
    formatNumCuenta(event: any) {
        let grupoMax = 0;
        grupoMax = ( this.level * 4) 
        let numCuenta = this.myForm.get('numCuentaForm').value.replace(/\D/g, '').substring(0, grupoMax); // Solo números, máximo N caracteres
        let formattedNumCuenta = '';
        let i = 0
        for (i; i < numCuenta.length; i++) {
           if (i > 0 && i % 4 === 0) {
               formattedNumCuenta += '-';
           }
           formattedNumCuenta += numCuenta[i];
        }

        this.conusltaCuenta = (grupoMax === i) ? true : false;

        this.myForm.patchValue({ numCuentaForm: formattedNumCuenta });

       
        
     }

    consultarAuxiliarCuenta() {
        this.dataReporteCuentaAux = [];
        this.saldoInicialTotal = 0;
        this.cargoTotal = 0;
        this.saldoFinalTotal = 0;
        this.abonoTotal = 0;
        let fechasFormValue = this.myForm.get('fechasForm').value;
        let mesInicial = (moment(fechasFormValue.startDate._d).month());
        //let mesFinal = (moment(fechasFormValue.endDate._d).month() +1 );
        let fechaFin = (moment(fechasFormValue.endDate._d).format('YYYY-MM-DD'));
        let fechaInicio = (moment(fechasFormValue.startDate._d).format('YYYY-MM-DD'));
        let añoInicial = moment(fechasFormValue.startDate._d).format('YY');
        this.NUMBERCuentaExcel = '';
        this.NAMECuentaExcel = '';
        const params = {
            loacs: sessionStorage.getItem('acslo'),
            ACCOUNT_ID: this.ACCOUNT_ID,
            DEBTOR :this.DEBTOR,
            fechaInicioMes:mesInicial,
            //fechaFinMes:fechaFin,
            fechaInicio:fechaInicio,
            fechaFin:fechaFin,
            anio:añoInicial
        };

        this._generalService.metodoCallParams(params, 'ReporteCuenta/consultarAuxiliarCuenta',true).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.dataReporteCuenta = tableResult.Table;
               
                if (tableResult.Table.length !== 0){
                    this.dataReporteCuentaAux =  this.dataReporteCuenta
                    this.saldoInicialTotal = this.dataReporteCuenta.reduce((total, row) => total + row.SaldoInical, 0);
                    this.cargoTotal = this.dataReporteCuenta.reduce((total, row) => total + row.CARGO, 0);
                    this.saldoFinalTotal = this.dataReporteCuenta.reduce((total, row) => total + row.SaldoFinal, 0);
                    this.abonoTotal = this.dataReporteCuenta.reduce((total, row) => total + row.ABONO, 0);
                    this.NAMECuentaExcel = this.dataReporteCuenta[0]['NAMECuenta'];
                    this.NUMBERCuentaExcel = this.dataReporteCuenta[0]['NUMBERCuenta'];
                    const structuredData = this.structureData(this.dataReporteCuenta );
                    //this.dataReporteCuentaAux = structuredData;
                    this.dataSource = new MatTableDataSource(structuredData);
                    
                }else{
                    this.dataSource = new MatTableDataSource;
                }

                if(this.dataReporteCuenta.length <= 0){ 
                    $(".mat-row").remove(".mat-row"); 
                }
            }, (error) => {
              console.log(error as any);
        });
    }
    structureData(data) {
        const result = [];
      
        // Agrupar los datos por ACCOUNT_ID
        const groupedByAccountId = data.reduce((acc, item) => {
          const { ACCOUNT_ID, ACCOUNT_NAME, NUMBERCuenta, NAMECuenta } = item;
          if (!acc[ACCOUNT_ID]) {
            acc[ACCOUNT_ID] = {
              ACCOUNT_NAME,
              NUMBERCuenta,
              NAMECuenta,
              items: []  // Inicializamos items como un array vacío
            };
          }
          acc[ACCOUNT_ID].items.push(item);  // Agregamos el item al array de items
          return acc;
        }, {});
      
        // Iterar sobre cada grupo de ACCOUNT_ID
        Object.keys(groupedByAccountId).forEach(accountId => {
            const account = groupedByAccountId[accountId];
            // Agregar una fila para el ACCOUNT con sumatorias
            const accountItem = {
                type: 'ACCOUNT',
                ACCOUNT_NAME: account.ACCOUNT_NAME,
                NUMBERCuenta: account.NUMBERCuenta,
                NAMECuenta: account.NAMECuenta,
            };
            result.push(accountItem);
        
            // Agregar las filas de datos regulares debajo del ACCOUNT si hay datos
            if (account.items.length > 0) {
                result.push(...account.items);
            }
        
            // Agregar la fila accountItemTotal debajo de todas las filas regulares
            const accountItemTotal = {
                type: 'ACCOUNTTOTAL',
            };
            result.push(accountItemTotal);
        });
        
      
        return result;
    }
      
    consultarNivel(){
        let metodo = 'ReporteCuenta/consultNivel';
        const params = { 
            loacs: sessionStorage.getItem('acslo')
        };
        this._generalService.metodoCallParams(params, metodo,true).subscribe(
          result => {
            const tableResult = JSON.parse(result);
            this.level = tableResult.Table[0].LEVEL;
        },error => {  console.log(<any>error);  });
    }
   
    consultarNombreCuenta(){
        this.ACCOUNT_ID = 0;
        let numeroCuenta = "";
        let metodo = 'ReporteCuenta/consultarNombreCuenta';
        numeroCuenta = this.myForm.controls['numCuentaForm'].value;
        const params = { 
            loacs: sessionStorage.getItem('acslo'),
            NUMBER:numeroCuenta
        };
  
        this._generalService.metodoCallParams(params, metodo,true).subscribe(
          result => {
            const tableResult = JSON.parse(result);
            this.dataCuenta= tableResult.Table;
           

            if (tableResult.Table.length !== 0) {
                this.myForm.get('nombreCuentaForm').setValue(this.dataCuenta[0].NAME);
                this.ACCOUNT_ID = tableResult.Table[0].ACCOUNT_ID;
                this.DEBTOR = tableResult.Table[0].DEBTOR;
                this.nombreCuneta = false;
                // saber si tiene ACCOUNT_SAT_ID relacionadas
                // if(tableResult.Table[0].ACCOUNT_SAT_ID == null){
                //     this.ACCOUNT_SAT_ID_Flahg = true;
                //     this._generalService.toastCall('¡Esta cuenta no tiene relación con pólizas!');
                // }else{
                    this.ACCOUNT_SAT_ID_Flahg = false;
                // }
                
              } else {
                this.nombreCuneta = true;
              }
           
          },
          error => {  console.log(<any>error);  }
        );
    }

    pantallaPoliza(idPoliza: number){
        const datosAdicionales = {
            origen: 'AuxCuenta',
        };
        
        const queryParams = { datos: btoa(JSON.stringify(datosAdicionales)) };

        this.router.navigate(['/app/polizas/polizas-editar/' + idPoliza], { queryParams }).then(
        nav => {
            console.log(nav);
        },
        err => {
            console.log(err);
        }
        );
    }
    //-------------------------------------Excel--------------------------------
    
    exportarExcel() {
        if (this.dataReporteCuenta.length > 0) {
            this.readyExport();
        }
    }
    
    readyExport() {
        let fechasFormValue = this.myForm.get('fechasForm').value;
        let mesInicial = (moment(fechasFormValue.startDate._d).format('YYYY-MM-DD'));
        let mesFinal = (moment(fechasFormValue.endDate._d).format('YYYY-MM-DD'));
        let tituloExcel = mesInicial + '/' + mesFinal + '' + this.NAMECuentaExcel;
        setTimeout(() => this.exportAsExcelFile(tituloExcel), 300);
    }
    
    public exportAsExcelFile(filename: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableAuxCuenta.nativeElement);
    
        const headersWorksheet = ['Fecha', 'Póliza', 'Partida', 'Referencia', 'Concepto Mov', '$Saldo Inicial', '$Cargo', '$Abono', '$Saldo Final','Total:'];
        for (const z in worksheet) {
            if (z[0] === '!') {
                continue;
            }
            if (worksheet[z]) {
                if (headersWorksheet.indexOf(worksheet[z].v + '') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'header');
                } else if (z.indexOf('F') > -1 || z.indexOf('G') > -1 || z.indexOf('H') > -1 || z.indexOf('I') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'decimal');
                }else if (z.indexOf('L') > -1 || z.indexOf('M') > -1 || z.indexOf('N') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'decimal');
                } else if (z.indexOf('O') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'porcentaje');
                } else if (((z + '').indexOf('D') > -1 || z.indexOf('H') > -1 || z.indexOf('K') > -1) && worksheet[z].t === 'n' && worksheet[z].z !== 'm/d/yy') {
                    this.wrapAndCenterCell(worksheet[z], 'decimal');
                }
            }
        }
    
        const workbook: XLSX.WorkBook = { Sheets: { General: worksheet }, SheetNames: ['General'] };
        const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        this.saveAsExcelFile(excelBuffer, filename);
    }
    
    private applyNegativeStyle(cell: XLSX.CellObject): void {
        const style = { font: { color: { rgb: 'FF0000' } } }; // Aplica el color rojo
        this.setCellStyle(cell, style);
    }
    
    private wrapAndCenterCell(cell: XLSX.CellObject, tipo: string) {
        let cellStyle: any = { alignment: { vertical: 'center', horizontal: 'center' } }; // Alineación de celda
    
        switch (tipo) {
            case 'header':
                cellStyle.font = { bold: true };
                break;
            case 'decimal':
                cellStyle.numFmt = '$#,##0.00';
                if (typeof cell.v === 'number' && cell.v < 0) {
                    cellStyle.font = { color: { rgb: 'FF0000' } };
                }
                break;
            case 'porcentaje':
                cellStyle.numFmt = '0.00%;\\(0.00%\\);\\-;@';
                break;
        }
    
        this.setCellStyle(cell, cellStyle);
    }
    
    private setCellStyle(cell: XLSX.CellObject, style: any): void {
        cell.s = style;
    }
    
    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    
    exportarPDF(row:any){
        // var dataExcel:dataPolizaPDF={
        //   fiscalName: '',
        //   numberPoliza: '',
        //   tipoPolizaName: '',
        //   creationDate: undefined,
        //   descripcion: '',
        //   detallePoliza: [],
        // };
        // dataExcel.tipoPolizaName = "Tipo Poliza";
        // dataExcel.creationDate = new Date();
        // dataExcel.descripcion="Descripción poliza";
        // dataExcel.fiscalName = "Numero Fiscal";
        // dataExcel.numberPoliza = "12345";
        // dataExcel.detallePoliza.push({abono:12,cargo:22,concepto:"Concepto 1",cuenta:"dfdf",descripcion:"ddf",partida:123,referencia:"dfdf"});
    
        this._generalService.metodoCallParams({POLIZA_ID:row.POLIZA_ID}, `poliza/getDataParaExportarPoliza`, true)
            .subscribe((dataExcel:dataPolizaPDF) => {
              this.descargarExcel(dataExcel);
              
            }, (error) => {
            });
    
       
    
    }
    descargarExcel(data:dataPolizaPDF)
    {
      
    
      const doc = new jsPDF("p", "pt", "letter");
      
      var totalCargo =data.detallePoliza.reduce((total, currentValue) => total + currentValue.cargo,0);
      var totalAbono =data.detallePoliza.reduce((total, currentValue) => total + currentValue.abono,0);
    
      var bodyTable=[
        [
            { text: 'Partida', bold: true, alignment: 'center' },
            { text: 'Cuenta', bold: true, alignment: 'center' },
            { text: 'Descripción', bold: true, alignment: 'center'},
            { text: 'Concepto', bold: true, alignment: 'center'},
            { text: 'Referencia', bold: true, alignment: 'center'},
            { text: 'Cargo', bold: true, alignment: 'center'},
            { text: 'Abono', bold: true, alignment: 'center' }
        ]
        ];
        data.detallePoliza.forEach(element => {
            bodyTable.push([
                {text: element.partida.toString(),bold: false, alignment: 'right'},
                {text: element.cuenta,bold: false, alignment: 'left'},
                {text: element.descripcion,bold: false, alignment: 'left'},
                {text: element.concepto,bold: false, alignment: 'left'},
                {text: element.referencia,bold: false, alignment: 'left'},
                {text:new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(element.cargo),bold: false, alignment: 'right'},
                {text:new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(element.abono),bold: false, alignment: 'right'}
            ])
        });
    var footerTable = [
      [
        {text: "", alignment: 'left',bold: false},
          {text: "", alignment: 'left',bold: false},
          {text: "", alignment: 'left',bold: false},
          {text: "", alignment: 'left',bold: false},
          {text: "Totales", alignment: 'left',bold: true},
          {text: new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(totalCargo), alignment: 'right',bold: true},
          {text: new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(totalAbono), alignment: 'right',bold: true},
      ]
    ];
      const documentDefinition:TDocumentDefinitions = { 
        content: [                      
          {text:data.fiscalName,alignment:"center"},
          {text:"Póliza",alignment:"center"},
          {
              layout: "noBorders",
              table: {
              
                widths: [ '20%', '20%', "20%",'20%', '20%' ],
              
                body: [
                  [ {text:"Núm. Póliza:",bold:true}, {text:data.numberPoliza,alignment:"left"},{text:""} ,{text:"Fecha Poliza:",bold:true}, {text:this._utils.changeFormatDate(data.creationDate,"dd-mm-yyyy" ),alignment:"left"} ],
                  [ { text: 'Tipo de Póliza:', bold: true ,marginTop:5}, {text:data.tipoPolizaName,alignment:"left",marginTop:5}, {text:""},{text:"",bold:true,marginTop:5}, {text:"",alignment:"left",marginTop:5} ],
                ]
              }
          },
          {text:"\n"}
          ,
          {
            layout: "noBorders",
            table: {
            
              widths: [ '15%', '85%' ],
            
              body: [
                [ {text:"Descripción:",bold:true}, {text:data.descripcion,alignment:"left"}],
                
              ]
            }
          }, 
          {
            style: 'tablePrincipal',
            table: {
                headerRows: 1,
                widths: ['8%',"17.5%","17.5%","13%","13%",'15%','15%'],
                body:bodyTable
            },
            
          },
          {
            layout: "noBorders",
            table: {
                widths: ['8%',"17.5%","17.5%","13%","13%",'15%','15%'],
                body:footerTable
            },
          }
      ],
    
      styles: {            
        tablePrincipal: {
          margin: [0, 20, 0, 0]
        },
        header: {
          bold: true,
          fontSize: 11,
          color: 'black',
          margin: [0, -5, 0, 0]
        },
      },
      defaultStyle: {
        // columnGap: 20
      },
      pageMargins: [20, 20, 20, 20],
     };
      
      let x = pdfMake.createPdf(documentDefinition).download(data.numberPoliza);
    }

}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/reporteAuxiliarCuenta/consultar/reporteAuxiliarCuenta-consultar.component.ts